module.exports = __webpack_public_path__ + "img/x1_en_2025_04_25@2x.e50c1c29.png";